export const USABLE_VIALS = 'usableVials';
export const UNUSABLE_VIALS = 'unusableVials';
export const EARMARKED = 'earmarked';
export const FORM_A = 'forma';
export const DESTRUCTION = 'destruction';
export const INCIDENT = 'incident';
// Earmark movement types
export const CREATED = 'created';
export const USED = 'used';
export const RETURNED = 'returned';

// campaign category for on_hold/is_test
export const REGULAR = 'REGULAR';
export const TEST_CAMPAIGN = 'TEST_CAMPAIGN';
export const CAMPAIGN_ON_HOLD = 'CAMPAIGN_ON_HOLD';
export const ALL_ROUNDS_ON_HOLD = 'ALL_ROUNDS_ON_HOLD';
export const ROUND_ON_HOLD = 'ROUND_ON_HOLD';
